import { useState } from 'react';

export const useLoading = (initial = true) => {
    const [isLoading, setLoading] = useState(initial);
    return { isLoading, setLoading };
};